function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_restart_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M0 141.7c0 92.7 63.5 134.6 141.7 134.6s141.7-41.9 141.7-134.6c0-49.3-17.9-84.2-46.4-106.1l46.5-.1V7.2h-92.6l.1 91.9 28.4-.1V57.7c1.4 1.1 2.9 2.2 4.2 3.4 21 18.1 31.7 45.2 31.7 80.6s-10.6 62.5-31.7 80.6c-19.5 16.8-47.8 25.6-81.7 25.6s-62.2-8.8-81.7-25.6c-21-18.1-31.6-45.2-31.6-80.6S39 79.2 60 61.1c19.5-16.8 47.8-25.7 81.7-25.7V7.1C63.5 7.1 0 49 0 141.7z"
})));